import AuthService from "../AuthService";
import {fetchJSON,fetchJSONPre} from "../../helpers/Helpers";

export default class GlobalsApi {

    static getSuburbs(country,callback) {

        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };
        fetchJSON('/api/globals/suburbs?country='+country, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
        });
    }

    static getCoutryIp(ip,callback){
        const options = {headers: {
            'Content-Type': 'application/json',
        }
    };
        fetchJSONPre('https://ipapi.co/'+ip+'/json/', options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
        });
    }

    static getNews(callback, all = false) {
        const options = {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        };

        const url = all ? '/api/globals/getNews?all=true' : '/api/globals/getNews';
        
        fetchJSON(url, options)
            .then((response) => {
                callback(response);
            })
            .catch((response) => {
                callback(response);
        });
    }
}
